import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { SearchMode, dataModelToQueryString, useDataModelContext } from "@/entities/data-model";
import type { AdvancedSearchLinkAttributes } from "@/entities/form-metadata";
import styles from "./AdvancedSearchLink.module.scss";

export const AdvancedSearchLink = ({ label }: AdvancedSearchLinkAttributes) => {
    const { t } = useTranslation();
    const dataModel = useDataModelContext();

    const handleClick = () => {
        const nextDataModel = structuredClone(dataModel);
        nextDataModel.searchMode = SearchMode.Advanced;
        const queryString = dataModelToQueryString(nextDataModel, "search");

        window.open(`?${queryString}`, "_self");
    };

    return (
        <button
            type="button"
            role="link"
            data-testid="toggle-classic-search-button"
            onClick={handleClick}
            className={classNames("link icon iconSettings", styles.mr12)}
        >
            {label ?? t("showAdvanced")}
        </button>
    );
};
